import { SET_ANALYTICS_CONTEXT, REMOVE_FROM_ANALYTICS_CONTEXT } from "redux/action_types";

export function setAnalyticsContext(payload) {
  return { type: SET_ANALYTICS_CONTEXT, payload };
}

export function removeFromAnalyticsContext(payload) {
  return { type: REMOVE_FROM_ANALYTICS_CONTEXT, payload };
}
